import { SDK_VERSION as _ } from "./chunk1178.js";
import { GLOBAL_OBJ as t } from "./chunk1079.js";
function S() {
  return o(t), t;
}
function o(n) {
  const r = n.__SENTRY__ = n.__SENTRY__ || {};
  return r.version = r.version || _, r[_] = r[_] || {};
}
export {
  S as getMainCarrier,
  o as getSentryCarrier
};
